/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

/**
 * `Aboriginal`, `Environmental`, and `Historic` are NPWS asset groups.

 */
export type AppAssetGroupFilter =
  (typeof AppAssetGroupFilter)[keyof typeof AppAssetGroupFilter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppAssetGroupFilter = {
  "Residential_&_SFPP": "Residential & SFPP",
  Agriculture: "Agriculture",
  Building: "Building",
  Catchments: "Catchments",
  Electricity: "Electricity",
  Infrastructure: "Infrastructure",
  Mining: "Mining",
  Plantations: "Plantations",
  Recreation: "Recreation",
  Aboriginal: "Aboriginal",
  Environmental: "Environmental",
  Historic: "Historic",
} as const;
